<template>
	<main class="agencyManagement-mgn-list" style="background: #f5f5fb">
		<div class="mainList">
			<el-form label-width="80px" :inline="true" @submit.native.prevent style="margin-left: 13px">
				<el-form-item>
					<el-cascader
						v-model="filterQuery.fb_region_code"
						placeholder="搜索省市区"
						size="small"
						:options="queyrAreaData"
						clearable
						@change="queryPageListData"
						:props="{
							value: 'id',
							label: 'name',
							emitPath: false,
							checkStrictly: true
						}"
					>
					</el-cascader>
				</el-form-item>
				<el-form-item>
					<el-input style="width: 150px" placeholder="代理商名称" v-model="filterQuery.fu_title" size="small">
					</el-input>
				</el-form-item>
			</el-form>

			<div style="display: flex; margin-left: auto">
				<template>
					<el-button
						type="primary"
						class="action-btn"
						size="small"
						style="margin-right: 15px; width: 70px"
						@click=";(currentPage = 1), queryPageListData()"
						>搜索</el-button
					>
					<el-button
						type="primary"
						class="action-btn"
						size="small"
						style="
							background: #f7f8fa;
							border: 1px solid #dcdcdc;
							color: #4b4b4b !important;
							margin-right: 12px;
							width: 70px;
						"
						@click="clearList"
						>重置</el-button
					>
				</template>
			</div>
		</div>
		<div>
			<section class="list-area">
				<div
					class="list-area-otis"
					v-if="
						$store.state.user.userInfo.type === $api.account.types.PLATFORM_ADMIN.value ||
						$permissions([SP31001, SP31002, SP31003, SP31004, SP31005])
					"
				>
					<template>
						<div style="display: flex; padding-left: 18px">
							<el-button
								type="primary"
								size="small"
								icon="el-icon-plus"
								style="margin-right: 15px"
								@click="openCreate"
								v-permission="SP31001"
								>新建</el-button
							>
							<el-button
								size="small"
								icon="el-icon-download"
								style="background: #f7f8fa; border: 2px solid #f7f8fa; color: #4b4b4b !important"
								@click="$refs.importDialog.dialogVisible = true"
								v-permission="SP31002"
								>批量创建</el-button
							>
							<el-button
								size="small"
								icon="el-icon-upload2"
								style="background: #f7f8fa; border: 2px solid #f7f8fa; color: #4b4b4b !important"
								@click="exportExcel('agency', '代理数据')"
								v-permission="SP31003"
								>导出</el-button
							>
						</div>
						<div>
							<el-button
								type="primary"
								size="small"
								icon="el-icon-delete"
								:class="multipleSelection.length === 0 ? 'box' : 'box2'"
								:disabled="multipleSelection.length === 0"
								@click="batchDelete()"
								v-if="multipleSelection.length > 0"
								v-permission="SP31004"
								>批量删除</el-button
							>
							<el-button
								type="primary"
								size="small"
								icon="el-icon-refresh-right"
								:class="multipleSelection.length === 0 ? 'box' : 'box2'"
								:disabled="multipleSelection.length === 0"
								@click="resetPwd(multipleSelection.map(item => item.uid))"
								v-if="multipleSelection.length > 0"
								v-permission="SP31005"
							>
								重置密码
							</el-button>
						</div>
					</template>
				</div>
				<el-table
					:data="listControl.data"
					row-class-name="row"
					tooltip-effect="dark"
					@selection-change="val => (this.multipleSelection = val)"
					:header-cell-style="{ background: '#FAFAFA', color: '#000000', height: '10px !important' }"
				>
					<el-table-column type="selection" width="60" align="center" v-if="$permissions([SP31003, SP31004, SP31005])">
					</el-table-column>
					<el-table-column type="index" label="ID" width="50" />
					<el-table-column align="left" label="代理级别">
						<template slot-scope="scope">
							{{ admin_levels.find(v => v.id == scope.row.admin_level)?.title }}
						</template>
					</el-table-column>
					<el-table-column align="left" label="辖区" prop="school.district_division">
						<template slot-scope="{ row }">
							{{
								row.district.level == 1
									? row.district.name
									: `${row.district.l1_name}/${row.district.l2_name}/${row.district.l3_name}`
							}}
						</template>
					</el-table-column>
					<el-table-column align="left" label="代理商名称" prop="account.realname" />
					<el-table-column align="left" label="代理商账号" prop="account.login_name" />
					<el-table-column align="left" label="账号状态" prop="account.state">
						<template slot-scope="scope">
							<div style="display: flex; justify-content: left; align-items: center">
								<span slot="reference" v-show="scope.row.account?.state === 0" style="margin-right: 5px">
									<i class="dotClass" style="background-color: #67c23a"></i>
								</span>
								<span slot="reference" v-show="scope.row.account?.state === 1" style="margin-right: 5px">
									<i class="dotClass" style="background-color: #b81a19"></i>
								</span>
								{{ scope.row.account?.state === 0 ? '使用中' : '已停用' }}
							</div>
						</template>
					</el-table-column>

					<template
						v-if="
							$store.state.user.userInfo.type === $api.account.types.PLATFORM_ADMIN.value ||
							$permissions([SP31006, SP31007, SP31008])
						"
					>
						<el-table-column align="center" label="操作" class-name="opscol" width="180">
							<template v-slot:default="slot">
								<div class="table-mgn2">
									<div style="color: #3f6af7" @click="openUpdate({ ...slot.row })" v-permission="SP31006">
										<el-tooltip content="编辑" placement="bottom" effect="light">
											<svg class="icon" aria-hidden="true">
												<use xlink:href="#icon-iconoutlinesetting"></use>
											</svg>
										</el-tooltip>
									</div>

									<div
										class="icon delete"
										style="color: #f13048"
										@click="promptRemove(slot.row.id)"
										v-permission="SP31007"
									>
										<el-tooltip content="删除" placement="bottom" effect="light">
											<svg
												class="icon"
												aria-hidden="true"
												style="width: 100%; height: 100%; outline: none; box-shadow: none"
											>
												<use xlink:href="#icon-deltred"></use>
											</svg>
										</el-tooltip>
									</div>

									<div
										v-if="slot.row.account.state === 0"
										class="icon delete"
										style="color: #f13048"
										@click="resetState(slot.row.id, 1)"
										v-permission="SP32008"
									>
										<el-tooltip content="禁用" placement="bottom" effect="light">
											<svg
												class="icon"
												aria-hidden="true"
												style="width: 100%; height: 100%; outline: none; box-shadow: none"
											>
												<use xlink:href="#icon-prohibit"></use>
											</svg>
										</el-tooltip>
									</div>
									<div
										v-else
										class="icon delete"
										style="color: #4ab96d"
										@click="resetState(slot.row.id, 0)"
										v-permission="SP32008"
									>
										<el-tooltip content="恢复" placement="bottom" effect="light">
											<i aria-hidden="true" class="icon el-icon-circle-check"></i>
										</el-tooltip>
									</div>

									<div style="color: #666666" @click="resetPwd([slot.row.uid])" v-permission="SP31008">
										<el-tooltip content="重置" placement="bottom" effect="light">
											<i aria-hidden="true" class="icon el-icon-refresh-right"></i>
										</el-tooltip>
									</div>
								</div>
							</template>
						</el-table-column>
					</template>
				</el-table>
				<div class="pagination-page">
					<span class="pagetotal">
						总计：{{ listControl.total }}条/{{ Math.ceil(listControl.total / listControl.pageSize) }}页
					</span>
					<el-pagination
						class="pagination"
						background
						@size-change="handleSizeChange"
						@current-change="handleCurrentChange"
						:page-size="listControl.pageSize"
						:total="listControl.total"
						:current-page.sync="listControl.currentPage"
						:page-sizes="[5, 10, 15, 20, 30]"
						layout="prev,pager,next,jumper,sizes"
						style="margin-top: 21px; margin-left: 10px"
					>
					</el-pagination>
				</div>
			</section>
		</div>

		<!-- 新建dialog -->
		<el-dialog
			class="practice-sheet-new-edit-dialog"
			width="400px"
			:close-on-click-modal="false"
			:visible.sync="dialogControl.visible"
		>
			<div class="dialog-title2" slot="title">
				<span>{{ dialogControl.title }}</span>
				<el-divider></el-divider>
			</div>
			<template>
				<el-form :model="dialogForm" ref="newForm" :rules="dialogFormRules" @submit.native.prevent="confirm">
					<el-form-item prop="title">
						<el-input placeholder="请输入代理商名称" v-model="dialogForm.title" style="width: 100%" size="medium" />
					</el-form-item>

					<el-form-item prop="admin_level" style="margin-top: 25px">
						<el-select
							placeholder="请选择代理级别"
							v-model="dialogForm.admin_level"
							style="width: 100%"
							size="medium"
							ref="myAutocomplete"
							@change="adminLevelChange"
						>
							<el-option v-for="item in admin_levels" :key="item.id" :label="item.title" :value="item.id" />
						</el-select>
					</el-form-item>

					<el-form-item prop="region_code" style="margin-top: 25px">
						<div>
							<el-cascader
								ref="areaRef"
								v-model="dialogForm.region_code"
								style="width: 100%"
								size="medium"
								placeholder="选择省/市/区"
								:options="areaData"
								:props="{
									value: 'id',
									label: 'name',
									emitPath: false
								}"
							/>
						</div>
					</el-form-item>
					<div style="margin-top: 25px"><el-divider /></div>
					<el-form-item
						style="margin-top: 20px; margin-bottom: 20px; display: flex; align-items: center; justify-content: center"
					>
						<el-button
							class="btn-close"
							@click="dialogControl.visible = false"
							style="width: 80px; height: 32px; line-height: 1px"
							>取 消</el-button
						>
						<el-button
							class="btn-prim"
							type="primary"
							native-type="submit"
							:loading="dialogControl.submitting"
							style="width: 80px; height: 32px; line-height: 1px"
						>
							{{ dialogControl.action == 'create' ? '保存' : '更新' }}
						</el-button>
					</el-form-item>
				</el-form>
			</template>
		</el-dialog>
		<!-- 批量导入 -->
		<batch-import-account ref="importDialog" :target="'agency'" />
	</main>
</template>
<script>
import {
	SP31001,
	SP31002,
	SP31003,
	SP31004,
	SP31005,
	SP31006,
	SP31007,
	SP31008,
	SP32008
} from '@/utils/permissionMap.js'
import { debounce } from 'lodash'
import BatchImportAccount from '@/components/BatchImportAccount'

export default {
	props: [],
	data() {
		return {
			SP31001,
			SP31002,
			SP31003,
			SP31004,
			SP31005,
			SP31006,
			SP31007,
			SP31008,
			SP32008,
			// 代理级别
			admin_levels: [
				{ id: 1, title: '省代' },
				{ id: 2, title: '市代' },
				{ id: 3, title: '区代' }
			],

			queyrAreaData: [], // 省市区数据，搜索用
			areaData: [], // 省市区数据，表单用

			// 多选
			multipleSelection: [], // 批量删除

			// 列表查询条件
			filterQuery: {
				fb_region_code: undefined,
				fu_title: ''
			},

			// 列表控制器
			listControl: {
				pageSize: 10,
				currentPage: 1,
				total: 0,
				data: []
			},

			// dialog 控制器
			dialogControl: {
				action: 'create', // create,update 新增和修改
				visible: false, // dialog 显示隐藏
				title: '', // dialog 标题
				confirmLabel: '', // dialog 确定标题
				submitting: false, // 提交加载状态
				id: '' // 当前修改的id
			},

			// dialog form 表单
			dialogForm: {
				title: '',
				region_code: '',
				admin_level: ''
			},

			// dialog form 校验规则
			dialogFormRules: {
				title: [
					{
						required: true,
						message: '请输入代理商名称',
						trigger: 'change'
					}
				],
				region_code: [
					{
						required: true,
						message: '未选择地区编号',
						trigger: 'change'
					}
				],
				admin_level: [
					{
						required: true,
						message: '未选择数据层级',
						trigger: 'change'
					}
				]
			}
		}
	},
	components: {
		BatchImportAccount
	},

	created() {
		this.queryRegionalLevel()
		this.queryPageListData()
	},
	methods: {
		// 获取省市区数据
		async queryRegionalLevel() {
			const req = this.$api.school.ssxlist(0)
			req.then(res => {
				this.areaData = this.areaLevelShow(res)
				this.queyrAreaData = JSON.parse(JSON.stringify(this.areaData))
			})
			req.catch(err => {
				console.log('省市区数据获取列表报错')
			})
		},
		// 省市区数据整理，控制显示层级
		areaLevelShow(data, level) {
			!data && (data = this.areaData)
			const handler = arr => {
				for (let i = 0; i < arr.length; i++) {
					const ele = arr[i]
					if (ele.child?.length) {
						let children = undefined
						if (level != undefined) {
							if (ele.level <= level && ele.level + 1 <= level) {
								children = ele.child
							}
						} else {
							children = ele.child
						}
						ele.children = children
						ele.children && handler(ele.children)
					}
				}
			}
			handler(data)
			return data
		},

		// 获取页面列表数据
		async queryPageListData(type) {
			let query = { ...this.filterQuery }
			if (type == 'refresh') query = {}

			this.dialogControl.submitting = false
			let res = await this.$api.agency.list({
				page: this.listControl.currentPage,
				page_size: this.listControl.pageSize,
				...query
			})
			this.listControl.total = res.meta.total
			this.listControl.pageSize = parseInt(res.meta.per_page)
			this.listControl.data = res.data
		},

		expandleChange(list) {
			for (var i = 0; i < list?.length; i++) {
				if (list[i].child?.length < 1) {
					list[i].child = undefined
				} else {
					this.expandleChange(list[i]?.child)
				}
			}
			return list
		},

		// 代理级别变化
		adminLevelChange(newVal) {
			this.dialogForm.regionList = []
			this.dialogForm.region_code = ''
			this.areaLevelShow(newVal)
			this.areaData = this.areaLevelShow(null, newVal)
		},

		// 创建打开dialog
		openCreate() {
			this.dialogControl.title = '新建代理'
			this.dialogControl.action = 'create'
			this.areaData = this.areaLevelShow()
			this.dialogForm.name = ''
			this.dialogForm.admin_level = ''
			this.dialogForm.region_code = ''
			this.dialogControl.visible = true
		},

		// 修改打开dialog
		async openUpdate(data) {
			this.dialogControl.title = `修改代理商 ${data.title}`
			this.dialogForm.title = data.title
			this.dialogForm.admin_level = data.admin_level
			this.dialogForm.region_code = data.region_code
			this.areaData = this.areaLevelShow(null, data.admin_level)

			this.dialogControl.id = data.id
			this.dialogControl.action = 'update'
			this.dialogControl.visible = true
		},

		// 新建代理
		confirm: debounce(async function () {
			await this.$refs['newForm'].validate()
			const data = { ...this.dialogForm }
			this.dialogControl.submitting = true
			if (this.dialogControl.action == 'create') {
				// try
				await this.$api.agency.create(data)
				this.dialogControl.visible = false
				this.queryPageListData('refresh')
			}

			if (this.dialogControl.action == 'update') {
				await this.$api.agency.update(this.dialogControl.id, data)
				this.dialogControl.visible = false
				this.queryPageListData('refresh')
			}
		}, 200),

		//每页下拉只显示的数据
		handleSizeChange(val) {
			console.log('val', val)
			this.listControl.pageSize = val
			this.queryPageListData()
		},

		//当前点击的是第几页
		handleCurrentChange(currentPage) {
			this.listControl.currentPage = currentPage
			this.queryPageListData()
		},

		// 重置搜索
		clearList() {
			this.filterQuery.fb_region_code = ''
			this.filterQuery.fu_title = ''
			this.queryPageListData()
		},

		// excel 导出
		async exportExcel(key, fileName) {
			const confirm = this.$confirm(`是否要导出登录密码?`, '温馨提示', {
				distinguishCancelAndClose: true,
				confirmButtonText: '是',
				cancelButtonText: '否',
				type: 'warning'
			})
			confirm.then(async () => {
				let blob = await this.$api.import_account.exportis(key, {
					ids: this.multipleSelection.map(item => {
						return item.uid
					}),
					has_password: true
				})
				this.downloadFile(blob, fileName)
			})
			confirm.catch(async action => {
				if (action === 'close') {
					return
				}
				let blob = await this.$api.import_account.exportis(key, {
					ids: this.multipleSelection.map(item => {
						return item.uid
					}),
					has_password: false
				})
				this.downloadFile(blob, fileName)
			})
		},

		// excel 导出下载
		downloadFile(blob, fileName) {
			const url = window.URL.createObjectURL(new Blob([blob]))
			let a = document.createElement('a')
			a.href = url
			// 保证下载文件后缀一致
			a.download = `${fileName}.xlsx`
			a.click()
			window.URL.revokeObjectURL(url)
		},

		// 密码重置，单个/多个
		async resetPwd(ids) {
			let confirm = await this.$confirm('此操作将重置密码, 是否继续?', '温馨提示', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning'
			})
				.then(_ => true)
				.catch(_ => false)

			if (!confirm) return

			this.$api.agency.resetPassword(ids).then(cRes => {
				if (cRes.success === true) {
					this.queryPageListData()
					this.$message({
						message: '重置密码成功，密码为：000000',
						type: 'success'
					})
				}
			})
		},

		//批量删除数据
		async batchDelete() {
			let confirm = await this.$confirm('此操作将删除该代理管理账号, 是否继续?', '温馨提示', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning'
			})
				.then(_ => true)
				.catch(_ => false)

			if (!confirm) return

			let idse = this.multipleSelection.map(item => item.uid)
			this.$api.agency.batchDelete({ ids: idse }).then(cRes => {
				if (cRes.success === true) {
					this.queryPageListData()
				}
			})
		},

		// 删除数据
		async promptRemove(id) {
			let confirm = await this.$confirm('此操作将删除该代理管理账号, 是否继续?', '温馨提示', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning'
			})
				.then(_ => true)
				.catch(_ => false)

			if (!confirm) return

			await this.$api.agency.delete(id)
			// 刷新
			this.queryPageListData()
		},

		// 单个状态修改
		async resetState(id, state) {
			let confirm = await this.$confirm('此操作将修改代理用户状态, 是否继续?', '温馨提示', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning'
			})
				.then(_ => true)
				.catch(_ => false)

			if (!confirm) return

			await this.$api.agency.resetState(id, state)
			this.queryPageListData()
		}
	}
}
</script>
<style lang="scss" scoped>
.arere {
	/deep/ .el-cascader .el-input .el-input__inner::placeholder {
		color: #323232;
	}
}

.action-btn:focus {
	background-color: #ff5e2a;
	border-color: #ff5e2a;
	opacity: 1 !important;
}

.box {
	margin-right: 15px;
	background: #9f9f9f;
	border: 2px solid #f7f8fa;
	color: #4b4b4b !important;
}

.box:hover {
	margin-right: 15px;
	background: #9f9f9f;
	border: 2px solid #f7f8fa;
	color: #4b4b4b !important;
}

.box2 {
	margin-right: 15px;
	background: #f7f8fa;
	border: 2px solid #f7f8fa;
	color: #4b4b4b !important;
}

.pagetotal {
	width: 200px;
	margin-left: 20px;
	font-size: 14px;
	line-height: 70px;
	font-family: PingFang SC-Medium, PingFang SC;
	font-weight: 500;
	color: #010101;
	text-overflow: ellipsis;
	white-space: nowrap;
	overflow: hidden;
}

.addr {
	font-size: 14px;
	color: #b4b4b4;
}

.dotClass {
	width: 10px;
	height: 10px;
	border-radius: 50%;
	display: block;
}

.schoolNianji {
	width: 32px;
	height: 28px;
	font-size: 16px;
	font-family: PingFang SC-Medium, PingFang SC;
	font-weight: 500;
	color: #323232;
	line-height: 28px;
	-webkit-background-clip: text;
}

.schollAxie {
	height: 35px;
	display: flex;
	-webkit-box-pack: justify;
	justify-content: space-between;
	vertical-align: middle;
	-webkit-box-align: center;
	align-items: center;
}

.schollApex {
	width: 32px;
	height: 28px;
	font-size: 16px;
	font-family: PingFang SC-Medium, PingFang SC;
	font-weight: 500;
	color: #323232;
	line-height: 28px;
	-webkit-background-clip: text;
	display: flex;
}

.el-form-item {
	margin-bottom: 1px;
}

.pagination {
	width: 100%;
	margin-top: 20px;
	text-align: right;
}

.pagination .el-pagination__total {
	float: left;
	font-size: 14px;
	font-family: PingFang SC-Medium, PingFang SC;
	font-weight: 500;
	color: #010101;
	-webkit-background-clip: text;
}

.pagination .el-pagination__jump {
	margin-left: 9px;
	font-weight: normal;
	color: #666666;
}

.ClassesRadio {
	margin-right: 32px;
	padding-bottom: 15px;
	font-size: 16px;
	font-family: PingFang SC-Medium, PingFang SC;
	font-weight: 500;
	color: #323232;
	-webkit-background-clip: text;
}

.ClassChekbox {
	margin-right: 8px;
	width: 90px;
	height: 32px;
	padding-bottom: 0px;
	font-size: 16px;
	font-family: PingFang SC-Medium, PingFang SC;
	font-weight: 500;
	color: #323232;
	-webkit-background-clip: text;
}
</style>
